import type { Ref } from 'react';
import React, { forwardRef, useCallback, useEffect } from 'react';
import {
  type LayoutChangeEvent,
  Platform,
  type Text,
  type TextProps,
} from 'react-native';
import { StyleSheet } from 'react-native';
import { useLayout } from 'react-native-web-hooks';
import { COLORS } from '@garnish/constants';

import { BodyText } from '../../Text';
import type { TabNavTextProps } from '../TabNav.types';

export const TabText = forwardRef((props: TabNavTextProps, ref: Ref<Text>) => {
  const { children, active, onChangeMeasures } = props;
  const { onLayout, width, height, x, y } = useLayout();

  useEffect(() => {
    if (onChangeMeasures) {
      onChangeMeasures({ width, height, x, y });
    }
  }, [width, height, x, y, onChangeMeasures]);

  const style = React.useMemo<TextProps['style']>(
    () => [
      {
        fontSize: 17,
        lineHeight: Platform.select({ android: 30, default: undefined }),
      },
      active ? styles.active : styles.inactive,
    ],
    [active],
  );

  const handleLayout = useCallback(
    (event: LayoutChangeEvent) => {
      onLayout(event);
    },
    [onLayout],
  );

  return (
    <BodyText onLayout={handleLayout} ref={ref} style={style}>
      {children}
    </BodyText>
  );
});

const styles = StyleSheet.create({
  active: { color: COLORS.GREEN_2 },
  inactive: { color: COLORS.OPACITY.DARK_KALE.DARKER },
});
